import { SaveWordsList } from "components/settings";
import { WidgetSettingFC } from "types/Setting";
import {
  convertWordsByParams,
  LINE_LIMIT_SPINNER,
  TOTAL_LINE_LIMIT_SPINNER,
  ValidationLimitProps,
  validationLimits,
} from "util/widgeTransformData";

interface SpinnerData {}

interface SpinnerProps {
  settingName: string;
}

export const SpinnerWordsList: WidgetSettingFC<SpinnerData, SpinnerProps> = (props) => {
  const { settings, updateAnyWidgetSetting, info } = props;

  const handleConvertData = ({ value }: ValidationLimitProps) => {
    return convertWordsByParams({
      value,
      lineLimit: LINE_LIMIT_SPINNER,
      totalLineLimit: TOTAL_LINE_LIMIT_SPINNER,
    });
  };

  const handleValidation = ({ value }: ValidationLimitProps): boolean => {
    return validationLimits({
      value,
      totalLineLimit: TOTAL_LINE_LIMIT_SPINNER,
    });
  };

  return (
    <SaveWordsList
      settingName={info.settingName}
      updateSetting={updateAnyWidgetSetting!}
      value={settings.nameList}
      onConvertData={handleConvertData}
      onValidation={handleValidation}
    />
  );
};
